import Feed from './routes/Feed.svelte';
import Vault from './routes/Vault.svelte';
import CreateModal from './components/organisms/CreateModal/CreateModal.svelte'
import Modal from './components/organisms/Modal/Modal.svelte'
import Chat from './routes/Chat.svelte';
import Profile from './routes/Profile.svelte';
import NotFound from './routes/NotFound.svelte';

export default {
  '/': Feed,
  '/newest': Feed,
  '/idea/:id': Modal,
  '/vault': Vault,
  '/yours': Vault,
  '/create': CreateModal,
  '/chat': Chat,
  '/profile': Profile,
  '*': NotFound
};